const hepatitis_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence review",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"form1[0].Page_1[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].Page_1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Indicate ##name##'s status of the disease?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2B"
      },
      "questions":[
         {
            "label":"Status of the Disease",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Active",
                  "dbqName":"form1[0].Page_2[0].Active[0]",
                  "sub":""
               },
               {
                  "main":"Remission",
                  "dbqName":"form1[0].Page_2[0].Remission[0]",
                  "sub":""
               }
            ],
            "answer":"Active"
         }
      ]
   },
   {
      "question":"Does ##name## require regular dialysis?",
      "sub":"",
      "type":"yesno",
      "dummy":true,
      "show": true,
      "message":"Please see Kidney DBQ.",
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2B"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"",
      "dbqName_no":"",
      "answer":""
   },
   {
      "question":"Does ##name## have voiding dysfunction?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "VOIDING DYSFUNCTION",
         number: "4A"
      },
      "presidence":"Yes",
      "maxLength":45,
      "ref":0,
      "dbqName_yes":"form1[0].Page_2[0].Yes4[0]",
      "dbqName_no":"form1[0].Page_2[0].No4[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please provide etiology of voiding dysfunction",
      "textdbqName":"form1[0].Page_2[0].IfYes[0]",
      "textanswer":""
   },
   {
      "question":"Does the voiding dysfunction cause urine leakage?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "VOIDING DYSFUNCTION",
         number: "4A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"form1[0].Page_2[0].Yes4a[0]",
      "dbqName_no":"form1[0].Page_2[0].No4a[0]",
      "answer":""
   },
   {
      "question":"Indicate severity if voiding dysfunction cause urine leakage",
      "sub":"Please select only one",
      "type":"radioTiles",
      "refId": 1,
      "multi": false,
      "show": false,
      "small": true,
      "cols": 2,
      "section": {
         page: "2",
         title: "VOIDING DYSFUNCTION",
         number: "4A"
      },
      "questions":[
         {
            "main":"Requires absorbent material which must be changed",
            "redMain":" more than 4 Times per Day",
            "dbqName":"form1[0].Page_2[0].Absorb40[0]",
            "answer":""
         },
         {
            "main":"Requires absorbent material which must be changed ",
            "redMain":"2 to 4 Times per Day",
            "dbqName":"form1[0].Page_2[0].Absorb3[0]",
            "answer":""
         },
         {
            "main":"Requires absorbent material that must be changed",
            "redMain":" less than 2 Times per Day",
            "dbqName":"form1[0].Page_2[0].Absorb2[0]",
            "answer":""
         },
         {
            "main":"Does not require the wearing of absorbent material",
            "dbqName":"form1[0].Page_2[0].Absorb1[0]",
            "answer":""
         }
         // ,
         // {
         //    "main":"The voiding dysfunction does not cause urine leakage",
         //    "dbqName":"form1[0].Page_2[0].No4a[0]",
         //    "answer":""
         // }
      ],
      "answer":""
   },
   {
      "question":"Does the voiding dysfunction require the use of an appliance?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "VOIDING DYSFUNCTION",
         number: "4B"
      },
      "presidence":"Yes",
      "maxLength":55,
      "ref":0,
      "dbqName_yes":"form1[0].Page_3[0].YesRequired[0]",
      "dbqName_no":"form1[0].Page_3[0].NoRequired[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe the appliance",
      "textdbqName":"form1[0].Page_3[0].IfYes3[0]",
      "textanswer":""
   },
   {
      "question":"Does the voiding dysfunction caused increased urinary frequency?",
      "sub":"Please check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 3,
      "section": {
         page: "3",
         title: "VOIDING DYSFUNCTION",
         number: "4C"
      },
      "questions":[
         {
            "main":"Daytime voiding interval between 2 and 3 hours",
            "dbqName":"form1[0].Page_3[0].Daytime1[0],form1[0].Page_3[0].Yes4b[0]",
            "answer":""
         },         
         {
            "main":"Daytime voiding interval between 1 and 2 hours",
            "dbqName":"form1[0].Page_3[0].Daytime2[0],form1[0].Page_3[0].Yes4b[0]",
            "answer":""
         },
         {
            "main":"Daytime voiding interval less than 1 hour",
            "dbqName":"form1[0].Page_3[0].Daytime3[0],form1[0].Page_3[0].Yes4b[0]",
            "answer":""
         },
         {
            "main":"Night time awakening to void 2 times",
            "dbqName":"form1[0].Page_3[0].Nighttime1[0],form1[0].Page_3[0].Yes4b[0]",
            "answer":""
         },
         {
            "main":"Night time awakening to void 3 to 4 times",
            "dbqName":"form1[0].Page_3[0].Nighttime2[0],form1[0].Page_3[0].Yes4b[0]",
            "answer":""
         },         
         {
            "main":"Night time awakening to void 5 or more times",
            "dbqName":"form1[0].Page_3[0].Nighttime3[0],form1[0].Page_3[0].Yes4b[0]",
            "answer":""
         },
         {
            "main":"No voiding dysfunction",
            "partialField": true,
            "dbqName":"form1[0].Page_3[0].No4b[0]",
            "answer":""
         }
      ],
      "answer":""
   },  
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "checkQuestion": 4,
      // "messages": "",
      // "realAnswer": "",
      "type":"textarea",
      "show": true,
      "section": {
         page: "4",
         title: "REMARKS",
         number: "12"
      },
      "options":[],
      "maxLength":980,
      "dbqName":"form1[0].Page_4[0].REMARKSIfany[0]",
      "answer":""
   },
]
   
    export default hepatitis_questions ;